const TERMINOLOGY = {
  school: {
    student: 'Student',
    students: 'Students',
    teacher: 'Teacher',
    school: 'School',
    class: 'Class',
    classes: 'Classes',
    showAcademicScore: true
  },
  camp: {
    student: 'Camper',
    students: 'Campers',
    teacher: 'Counselor',
    school: 'Camp',
    class: 'Bunk',
    classes: 'Bunks',
    showAcademicScore: false
  }
};

export function getTerminology(schoolType) {
  return TERMINOLOGY[schoolType] || TERMINOLOGY.school;
}
